import {
  useMediaQuery,
  WhmSkeleton,
  WhmStack,
  whmTheme,
} from "@securitize/reactjs-whm";
import StyledCard from "../../../StyledCard";

export default function SkeletonCard() {
  const isMobile = useMediaQuery(whmTheme.breakpoints.down("xl"));

  if (isMobile) {
    return (
      <WhmStack width="100%" gap="16px">
        {new Array(3).fill(0).map((_, index) => (
          <StyledCard key={index}>
            <WhmStack width="100%" gap="16px">
              <WhmStack
                direction="row"
                gap="8px"
                sx={{ flex: 2, alignItems: "center" }}
              >
                <WhmSkeleton variant="circular" width={32} height={32} />
                <WhmSkeleton variant="rounded" sx={{ flex: 1 }} height={40} />
                <WhmSkeleton variant="rounded" height={40} sx={{ flex: 1 }} />
              </WhmStack>
            </WhmStack>
          </StyledCard>
        ))}
      </WhmStack>
    );
  }

  return (
    <WhmStack width="100%" gap="16px">
      {new Array(3).fill(0).map((_, index) => (
        <StyledCard key={index}>
          <WhmStack direction="row" gap="16px" sx={{ alignItems: "center" }}>
            <WhmStack
              direction="row"
              gap="8px"
              sx={{ flex: 2, alignItems: "center" }}
            >
              <WhmSkeleton variant="circular" width={32} height={32} />
              <WhmSkeleton variant="rounded" sx={{ flex: 1 }} height={40} />
            </WhmStack>
            <WhmStack direction="row" gap="24px" sx={{ flex: 4 }}>
              <WhmSkeleton variant="rounded" height={40} sx={{ flex: 1 }} />
              <WhmSkeleton variant="rounded" height={40} sx={{ flex: 1 }} />
              <WhmSkeleton variant="rounded" height={40} sx={{ flex: 1 }} />
              <WhmSkeleton variant="rounded" height={40} sx={{ flex: 1 }} />
            </WhmStack>
            <WhmSkeleton variant="rounded" sx={{ flex: 1 }} height={40} />
          </WhmStack>
        </StyledCard>
      ))}
    </WhmStack>
  );
}
